// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dompurify from "dompurify";
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
  HighlightedText // 검색어 하이라이팅
} from 'Admin/Component/AdFunc';

// API
import { AdNewsApi, AdNewsCatApi, AdNewsListApi, AdNewsUseApi } from '_Route/Api';
import Loading from 'Admin/Component/Loading';


const AdNews = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sanitizer = dompurify.sanitize;

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [newsData, setNewsData] = useState({
    pageList: [], // News Page List
    resList: [], // News Result List
    catList: [], // News Category List
  })
  const { pageList, resList, catList } = newsData

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 게시물 갯수
  const [count, setCount] = useState('');

  // 필터 옵션
  const setNewsLang = (value) => {
    setFilterOpt({...filterOpt,
      news_lko: value === 'en' ? undefined : '1',
      news_len: value === 'ko' ? undefined : '1',
    })
  }
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    news_category: '',
    news_create_date: '',
    news_last_modify_date: '',
    news_lko: '',
    news_len: '',
  })
  const { search_key, search_val, news_category, news_create_date, news_last_modify_date, news_lko, news_len } = filterOpt;

  // Column name / Sort var
  const columnList = [
    {name: 'ID', key: 'news_no'},
    {name: '카테고리', key: 'news_category'},
    {name: '태그', key: 'news_tag'},
    {name: '제목', key: 'news_title'},
    {name: '내용', key: 'news_content'},
    {name: '작성자', key: 'news_create_user'},
    {name: '작성 일시', key: 'news_create_date'},
    {name: '마지막 수정자', key: 'news_last_modify_user'},
    {name: '마지막 수정 일시', key: 'news_last_modify_date'},
    {name: '언어', key: 'news_lang'},
    {name: '수정', key: 'news_use', access_score: 300},
  ]; 
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/news/list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }

  const onJSON = (data) => {
    try {
      const parseData = JSON.parse(data)
      let resData = '';
      parseData?.map((tag, i) => {
        resData += (parseData.length === i + 1) ? tag : tag + ', '
      })
      return resData;
    }
    catch (err) {
      return data
    }
  }


  /* ========================================================================
  * Axios News
  ========================================================================*/
  const [update, setUpdate] = useState(false); // 리스트 상태 업데이트 변수

  // GET News Category List
  useEffect(() => {
    axios.get(AdNewsCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      console.log(res, "GET News Category List Success!")
      newsData.catList = res.data.result
    })
    .catch(err => {
      console.error(err, "GET News Category List Error...");
    })
  }, [])

  // GET News List
  useEffect(() => {
    setLoading(false)
    axios.get(AdNewsListApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt
    })
    .then(res => {      
      let sortData = res.data.result;

      newsData.pageList = res.data.pageInfo;
      newsData.resList = CurPageList(sortData, sortType, sortState, curPage, pageSize)
      setNewsData({...newsData})
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET News List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, update, search_key, news_category, news_create_date, news_last_modify_date, news_lko, news_len])
  
  // PUT News
  const UpdateNews = (newsUuid) => {
    axios({
      url: AdNewsUseApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        news_uuid: newsUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`News 노출 여부 변경${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      setUpdate(!update)
    })
    .catch(err => {
      console.error("PUT News List ERROR...", err);
    })
  }

  // DELETE News
  const DeleteNews = (newsUuid, index) => {
    axios({
      url: AdNewsApi,
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        news_uuid: newsUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      if(index === checkItems.length - 1) {
        alert(`${checkItems.length}개의 게시물 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdate(!update)
    })
    .catch(err => {
      // console.error("DELETE News List ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }
  
  // 일괄 삭제 함수
  const deleteFunc = () => {
    if(checkItems.length === 0) {
      alert('삭제할 게시물을 선택해주세요.')
    } else {
      if(window.confirm(`${checkItems.length}개의 게시물을 선택하셨습니다. \n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
        checkItems.map((id, i) => { DeleteNews(id, i) })
        setCheckItems([])
      }
    }
  }

  
  return (
    <>
      <div className="adContTitGroup">
        <h2>News</h2>
        <p>Home / News <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* News 게시물을 <span className="blueTxt">조회/관리</span>할 수 있습니다.</li>
        </ul> 
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            {
              userScore >= 300 &&
              <button type="button" className="btn xs red round_10" onClick={deleteFunc}>선택 삭제</button>
            }
            
            <div className="fieldGroup">
              <label>노출 게시물 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>카테고리</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="news_category" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  {catList.map((c, i) =>
                    <option key={i} value={c.news_cat}>{c.news_cat}</option>
                  )}
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>언어</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setNewsLang(e.target.value)}>
                  <option value="">전체</option>
                  <option value="ko">한글</option>
                  <option value="en">영어</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>작성 일시</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="news_create_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>마지막 수정 일시</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="news_last_modify_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>콘텐츠 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="news_title">제목</option>
                  <option value="news_content">내용</option>
                  <option value="news_tag">태그</option>
                  <option value="news_create_user">작성자</option>
                  <option value="news_last_modify_user">마지막 수정자</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
            
            {
              userScore >= 200 &&
              <button type="button" className="btn xs sfrtBlue round_10" onClick={() => navigate('/admin/news/view/add')}>글 등록</button>
            }
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, resList, 'news_uuid'))} checked={checkItems.length === resList.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  (userScore >= list?.access_score || list.access_score === undefined) &&
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                resList.length !== 0 ?
                  resList.map((data, i) => 
                    <tr key={i}>
                      <td>
                        <div className="checkGroup">
                          <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data.news_uuid, checkItems))} checked={checkItems.includes(data.news_uuid) ? true : false}/>
                          <label htmlFor={`check_${i}`}></label>
                        </div>
                      </td>
                      <td>{data.news_no}</td>
                      <td>{data.news_cat}</td>
                      <td style={{minWidth: '150px'}}>{onJSON(data.news_tag)}</td>
                      <td style={{minWidth: '150px', maxWidth: '300px'}}>{data.news_title}</td>
                      <td><div className="innerBox" style={{minWidth: '250px', maxWidth: '400px'}} dangerouslySetInnerHTML={{ __html: sanitizer(data.news_content.replace(/<[^>]*>?/g, ''))}}></div></td>
                      <td>{data.news_create_user}</td>
                      <td>{moment(data.news_create_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.news_last_modify_user}</td>
                      <td>{moment(data.news_last_modify_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.news_lang}</td>
                      {
                        userScore >= 300 &&
                        <td style={{width: '125px'}}>
                          <div className="btnArea full col">
                            <button type="button" className={`btn xs ${data?.news_use === 1 ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => UpdateNews(data.news_uuid)}>{data?.news_use === 1 ? '사용' : '미사용'}</button>
                            <button type="button" className="btn xs green round_10" onClick={() => navigate(`/admin/news/view/${data.news_uuid}`)}>글 수정</button>
                          </div>
                        </td>
                      }
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {pageList.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdNews;